/**
 * @fileoverview Flight Crew Dead-Letter API Service
 * @description API calls for searching the Service Bus dead-letter queue
 */

import { apiClient } from '@/services';

const BASE = '/v1/flight-crew-deadletter';

export const flightCrewDeadletterApi = {
  health: () => apiClient.get(`${BASE}/health`),

  /**
   * Search DLQ by flight number and date
   * @param {string} flightNumber - Flight number (e.g. "570")
   * @param {string} date - Date in YYYY-MM-DD format
   * @returns {Promise<{total_scanned, match_count, matches[], error}>}
   */
  search: (flightNumber, date) =>
    apiClient.post(`${BASE}/search`, {
      flight_number: flightNumber,
      date,
    }),
};
